import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

export function ItemCombobox({ items, value, onSelect, placeholder = "Pick item", testId, labelFn, afterSelect, triggerClass = "h-9" }) {
  const [open, setOpen] = useState(false);
  const sel = items.find(x => x.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testId}
          role="combobox" aria-expanded={open} aria-haspopup="listbox" data-auto-open="true" data-placeholder={sel ? undefined : ""}
          className={`w-full justify-between rounded-sm bg-secondary border-border ${triggerClass} text-xs font-normal px-3`}>
          <span className="truncate">{sel ? labelFn(sel) : <span className="text-muted-foreground">{placeholder}</span>}</span>
          <ChevronDown className="w-3 h-3 opacity-50 shrink-0 ml-1"/>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 bg-card border-border w-[--radix-popover-trigger-width]" align="start">
        <Command>
          <CommandInput placeholder="Search name / part no / item code…" data-testid={`${testId}-search`} className="h-8 text-xs"/>
          <CommandList className="max-h-56">
            <CommandEmpty>No items match.</CommandEmpty>
            {items.map(x => (
              <CommandItem key={x.id} value={x.item_name}
                keywords={[x.part_number || "", x.item_code || "", x.company || ""]}
                data-testid={`${testId}-opt-${x.id}`}
                onSelect={() => { onSelect(x); setOpen(false); afterSelect?.(); }}
                className="text-xs cursor-pointer">
                {labelFn(x)}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
